import { render, staticRenderFns } from "./quote.vue?vue&type=template&id=b18a9eaa"
import script from "./quote.vue?vue&type=script&lang=js"
export * from "./quote.vue?vue&type=script&lang=js"
import style0 from "./quote.vue?vue&type=style&index=0&id=b18a9eaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports